import { useCustomSWR } from 'utils/hooks/fetchers'

export const useServiceClassification = (id) => {
  return useCustomSWR(id ? `/serviceClassifications/${id}` : null)
}
